import React from 'react'
import image from '../assets/BurgerZombiesSmallLogo.png'
import PageLinks from './PageLinks'

const Navbar = () => {
    return ( 
        <div className='nav-container h-16 sm:h-20 sm:top-0'>
            <div className="logo-container w-16 sm:w-20">
                <a href = '/'>
                    <img src={image} className="logo-image " alt=""/>
                </a>
            </div>
            <PageLinks/>
        </div>
    )
}

export default Navbar   